import api from "./apiClient";

const API_URL = process.env.VUE_APP_API_BASE_URL + '/api/v2/';

export default {
  async listar(params) {
    const response = await api.get(API_URL + "movimientos", { params,
    });
    if (response.data) return response.data;
  },
};
